import { IS_FLIPGIVE } from './env';

/**
 * AppsFlyer OneLink base URL (no trailing slash). A plain code constant — it does NOT vary by
 * deployment environment. Lives in its own file (not `env.ts`) so Metro's `.native` resolution
 * never shadows it; `IS_FLIPGIVE` resolves correctly on web and native.
 */
export const ONE_LINK_BASE_URL = IS_FLIPGIVE
    ? 'https://flipgive1.onelink.me/D3HI'
    : 'https://raiseright.onelink.me/Gei8';
